//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'RenalFailure',
  data () {
    return {
      form: {
        scr: '',
        urineNa: '',
        ucr: ''
      },
      urea: 'urea_bun',
      hasScore: false,
      disabled: false,
      bun_value: '',
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        let result = form.urineNa * form.scr / form.ucr
        if (result < 1) {
          self.descTxt = '肾前性氮质血症'
        } else if (result > 2) {
          self.descTxt = '急性肾小管坏死'
        }
        return String(result.toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/RenalFailure.vue